class Header {
    mainContainer;
    btnBurger;
    menu;

    constructor(elm) {
        this.mainContainer = elm;
        this.btnBurger = this.mainContainer.querySelector('.header__burger');
        this.menu = this.mainContainer.querySelector('.header__nav-menu');

        this.init();
    }

    init() {
        this.btnBurger.addEventListener('click', (e) => {
            e.preventDefault();
            if (!this.menu.classList.contains('active')) {
                this.showMenu();
            } else {
                this.hideMenu();
            }
        })

        document.addEventListener('click', (e) => {
            if (this.menu.classList.contains('active') && 
                !this.menu.contains(e.target) &&
                !this.btnBurger.contains(e.target)
            ) {
                this.hideMenu();
            }
        });
    }

    showMenu() {
        this.menu.classList.add('active');
        this.btnBurger.classList.add('active');
    }

    hideMenu() {
        this.menu.classList.remove('active');
        this.btnBurger.classList.remove('active');
    }
}

document.addEventListener('DOMContentLoaded', () => {
    const elm = document.querySelector('.header');
    if (elm) {
        new Header(elm);
    }
})